import { mapGetters } from "vuex";
import isWhistleAdmin from "./isWhistleAdmin";

export default {
  mixins: [isWhistleAdmin],
  computed: {
    ...mapGetters(["hasPermission"]),
    canManageProgramSetup() {
      return this.isWhistleAdmin || this.hasPermission("admin:manage:client-program-setup");
    },
  },
};
